import keyMirror from 'react-utils/keyMirror';
const TwoFactorAuthSMSErrors = keyMirror({
  SMS_NOT_SENT: null,
  NUMBER_ALREADY_REGISTERED: null
});
export default TwoFactorAuthSMSErrors;